import React from "react";
import { Button, ButtonGroup } from "reactstrap";

function AdrTypeSelectorV3(props) {
  const handleClick_drType = (e) => {
    e.preventDefault();
    if (!props.isReadOnly) {
      const isCem4501 = e.target.name === "cem4501";
      props.changeDrType(isCem4501);
    }
  };

  return (
    <div className="m-2">
      <div className="form-row form-group mb-2 pl-1">
        <ButtonGroup size="sm">
          <Button
            name="cem4601"
            id={`cem4601_${props.tabId}`}
            color="secondary"
            outline
            onClick={handleClick_drType}
            active={props.selectedDrType === "cem4601"}
            // If disabled, active behavior disappears. We still want CEM-4501
            // to show active status even when DR isReadOnly, so 'disabled' must
            // be false if selectedDrType === 'cem4601'
            disabled={props.isReadOnly && props.selectedDrType !== "cem4601"}
          >
            {props.selectedDrType === "cem4601" ? <b>CEM-4601</b> : "CEM-4601"}
          </Button>
          <Button
            name="cem4501"
            id={`cem4501_${props.tabId}`}
            color="secondary"
            outline
            onClick={handleClick_drType}
            active={props.selectedDrType === "cem4501"}
            disabled={props.isReadOnly && props.selectedDrType !== "cem4501"}
          >
            {props.selectedDrType === "cem4501" ? <b>CEM-4501</b> : "CEM-4501"}
          </Button>
        </ButtonGroup>
        <label className="my-auto ml-2">
          {props.selectedDrType === "cem4601"
            ? "Assistant RE/SR Daily Report"
            : props.selectedDrType === "cem4501"
            ? "RE/SR Daily Report"
            : ""}
        </label>
      </div>
    </div>
  );
}

export default AdrTypeSelectorV3;
